/** Fit a page under the table controls within a bounded viewport. */
export function listPageSizeForHeight(height: number, mobile: boolean, grouped: boolean): number {
  const rowHeight = mobile ? 36 : 40;
  const chromeHeight = 40 + rowHeight + (grouped ? rowHeight + 36 : 0) + 8;
  return Math.max(1, Math.floor((height - chromeHeight) / rowHeight));
}
